// react components
import React, {
    useEffect,
    useState,
} from 'react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'
import {
    useLocation,
} from 'react-router-dom'

// data
import {
    defaultReduxState,
    groupingIdsSite,
    reduxModalErrorEventHandlerSite,
} from 'data'

// serializers
import {
    CustomCSSProperties,
    MainStyleSerializer,
    PortfolioPageContentListSiteSerializer,
} from 'serializers/site'

// services
import {
    getStylesNew,
    parseQuerySite,
} from 'services'

import * as templateBlock from './index'

// props
type TemplateBlock803SiteProps = {
    blockId: string
    content: PortfolioPageContentListSiteSerializer[]
    detailId: string | undefined
    devId: string | undefined
    inListIndex?: number
    isInComponent?: boolean
    isEditHovered: boolean
    isInDetailPage?: boolean
    isInVideoBlock?: boolean
    mainParentId?: number
    object: PortfolioPageContentListSiteSerializer
    pageSlug: string | undefined
    parentArray?: number[]
    parentStyles?: any
    styles: MainStyleSerializer
    stylesEdit: MainStyleSerializer | undefined
}

// main
export const TemplateBlock803Site: React.FC<TemplateBlock803SiteProps> = React.memo(({
    blockId,
    content,
    detailId,
    devId,
    inListIndex,
    isEditHovered,
    isInComponent,
    isInDetailPage,
    isInVideoBlock,
    mainParentId,
    object,
    pageSlug,
    parentArray,
    parentStyles,
    styles,
    stylesEdit,
}) => {

    const dispatch = useDispatch()
    const location = useLocation()
    const reduxFormSitehoveredBlockId = useSelector((state: defaultReduxState) => state.reduxFormSite.hoveredBlockId)
    const reduxFormSiteparentContent = useSelector((state: defaultReduxState) => state.reduxFormSite.parentContent)
    const reduxFormSiteeditAutoSave = useSelector((state: defaultReduxState) => state.reduxFormSite.editAutoSave)
    const reduxFormSiteeditAutoSaved = useSelector((state: defaultReduxState) => state.reduxFormSite.editAutoSaved)
    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)

    const deviceType = reduxModalSite.deviceType

    const [activeTab, setActiveTab] = useState<number>(Number(parseQuerySite(location.search)?.activeTab) || 0)
    const [stylesNew, setStylesNew] = useState<{
        stylesTabs: CustomCSSProperties | undefined,
        stylesViews: CustomCSSProperties | undefined,
    } | undefined>(applyStyles())

    useEffect(() => {
        setStylesNew(applyStyles())
    }, [
        object.id,
        reduxModalSite,
        styles,
        stylesEdit,
    ])

    function applyStyles() {
        try {
            return {
                stylesTabs: getStylesNew(reduxModalSite, content?.[0]?.styles, stylesEdit),
                stylesViews: getStylesNew(reduxModalSite, content?.[1]?.styles, stylesEdit),
            }
        } catch (error) {
            dispatch(reduxModalErrorEventHandlerSite(
                error,
                'TemplateBlock803Site',
                'applyStyles',
            ))
        }
    }

    const tabsComponent: PortfolioPageContentListSiteSerializer[] = []
    const viewsArray: PortfolioPageContentListSiteSerializer[] = []
    content?.[0]?.content?.map((val: any) => {
        tabsComponent.push(val)
    })
    content?.[1]?.content?.map((val: any) => {
        viewsArray.push(val)
    })

    return (
        <div
            id={blockId}
            className={`template-block-803${reduxFormSiteparentContent === object.id ? ' active' : ''}${isEditHovered ? ' is-edit-hovered' : ''} ${deviceType}`}
        >
            <div
                className='t-803-tabs'
                style={stylesNew?.stylesTabs}
            >
                {tabsComponent?.filter(obj => obj.active === true).map((val, index) => {
                    // @ts-ignore
                    const Component = templateBlock[`TemplateBlock${val.layout}Site`]
                    const contentBlockId = `content-new-child-${val.id}-layout-${val.layout}`
                    return (
                        <Component
                            key={val.id}
                            activeTabId={tabsComponent[activeTab]?.id}
                            blockId={contentBlockId}
                            content={(!groupingIdsSite.includes(val.layout!) && inListIndex !== undefined) ? val.content[inListIndex] : val.content}
                            detailId={detailId}
                            devId={devId}
                            disableInfiniteScroll={true}
                            hasMore={false}
                            inListIndex={groupingIdsSite.includes(val.layout!) ? inListIndex : undefined}
                            isEditHovered={reduxFormSitehoveredBlockId === val.id}
                            isInComponent={isInComponent || ['f', 'n'].includes(object.layout_type!)}
                            isInDetailPage={isInDetailPage}
                            isInVideoBlock={isInVideoBlock || object.layout_type === 'v'}
                            mainParentId={mainParentId || object.id}
                            object={val}
                            onClick={() => setActiveTab(index)}
                            onSearchNext={undefined}
                            pageSlug={pageSlug}
                            parentArray={parentArray ? [object.id, ...parentArray] : [object.id]}
                            parentStyles={object.styles}
                            skipActiveCheck
                            styles={val.styles}
                            stylesEdit={reduxFormSiteeditAutoSave[val.id!]?.styles || reduxFormSiteeditAutoSaved[val.id!]?.styles}
                        />
                    )
                })}
            </div>
            <div
                className='t-803-views'
                style={stylesNew?.stylesViews}
            >
                {viewsArray?.filter(obj => obj.active === true).map((val, index) => {
                    if (index !== activeTab) return null
                    // @ts-ignore
                    const Component = templateBlock[`TemplateBlock${val.layout}Site`]
                    const contentBlockId = `content-new-child-${val.id}-layout-${val.layout}`
                    return (
                        <Component
                            key={val.id}
                            blockId={contentBlockId}
                            content={(!groupingIdsSite.includes(val.layout!) && inListIndex !== undefined) ? val.content[inListIndex] : val.content}
                            detailId={detailId}
                            devId={devId}
                            disableInfiniteScroll={true}
                            hasMore={false}
                            inListIndex={groupingIdsSite.includes(val.layout!) ? inListIndex : undefined}
                            isEditHovered={reduxFormSitehoveredBlockId === val.id}
                            isInComponent={isInComponent || ['f', 'n'].includes(object.layout_type!)}
                            isInDetailPage={isInDetailPage}
                            isInVideoBlock={isInVideoBlock || object.layout_type === 'v'}
                            mainParentId={mainParentId || object.id}
                            object={val}
                            onSearchNext={undefined}
                            pageSlug={pageSlug}
                            parentArray={parentArray ? [object.id, ...parentArray] : [object.id]}
                            parentStyles={object.styles}
                            styles={val.styles}
                            stylesEdit={reduxFormSiteeditAutoSave[val.id!]?.styles || reduxFormSiteeditAutoSaved[val.id!]?.styles}
                        />
                    )
                })}
            </div>
        </div>
    )
})
